module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8004.096890e5.png";